type IntersectionEntries = Array<IntersectionObserverEntry | null>;

export const getNextItem = (intersections: IntersectionEntries) => {
  const lastItemDisplayedIndex = [...intersections]
    .reverse()
    .findIndex((intersection) => intersection?.intersectionRatio === 1);
  return intersections[intersections.length - lastItemDisplayedIndex] ?? null;
};

export const hasNextItem = (intersections: IntersectionEntries) => {
  const lastItem = intersections[intersections.length - 1];
  return lastItem?.intersectionRatio !== 1;
};

export const isNextItem = (intersections: IntersectionEntries, element: HTMLElement) => {
  const nextItem = getNextItem(intersections);
  return nextItem?.target === element;
};

export const getPreviousItem = (intersections: IntersectionEntries) => {
  const firstDisplayedIndex = intersections.findIndex(
    (intersection) => intersection?.intersectionRatio === 1,
  );
  return intersections[firstDisplayedIndex - 1] ?? null;
};

export const hasPreviousItem = (intersections: IntersectionEntries) => {
  const firstItem = intersections[0];
  return firstItem?.intersectionRatio !== 1;
};

export const isPreviousItem = (intersections: IntersectionEntries, element: HTMLElement) => {
  const previousItem = getPreviousItem(intersections);
  return previousItem?.target === element;
};

export const hasNavigation = (intersections: IntersectionEntries) =>
  hasPreviousItem(intersections) || hasNextItem(intersections);

export const LEFT_OFFSET = 48;
export const RIGHT_OFFSET = 48;

export const getNextPosition = (
  currentPosition: number,
  wrapper: HTMLElement,
  intersections: IntersectionEntries,
) => {
  const nextItem = getNextItem(intersections);
  if (nextItem) {
    return (
      currentPosition +
      (nextItem.target.getBoundingClientRect().right -
        wrapper.getBoundingClientRect().right +
        RIGHT_OFFSET)
    );
  }
  return false;
};

export const getPreviousPosition = (
  currentPosition: number,
  wrapper: HTMLElement,
  intersections: IntersectionEntries,
) => {
  const previousItem = getPreviousItem(intersections);

  if (previousItem) {
    return Math.max(
      0,
      currentPosition -
        (wrapper.getBoundingClientRect().left -
          previousItem.target.getBoundingClientRect().left +
          LEFT_OFFSET),
    );
  }
  return false;
};
